import {createReducer} from '@reduxjs/toolkit'
import {RootState} from '../configureStore'
import {SettingsState} from '../types/AppState'

// TODO: switch this over to using new reducer style

// reducers are using Redux Starter Kit and Immer
// https://redux-starter-kit.js.org/api/createreducer

// app settings
export const DATA_RANGE_IP = "DATA_RANGE_IP"
export const DATA_RANGE_OPCRD = "DATA_RANGE_OPCRD"
export const TABLEAU_API_HOST = "TABLEAU_API_HOST"

// company settings
export const DEMO_COMPANY_MESSAGE = "DEMO_COMPANY_MESSAGE"
export const STORYBOARD_HOME_PAGE = "STORYBOARD_HOME_PAGE"

export const NOTIFICATIONS = "NOTIFICATIONS"
export const MARK_NOTIFICATIONS_UNREAD = "MARK_NOTIFICATIONS_UNREAD"

// icd10tree
export const ICD10TREE = "ICD10TREE"
export const ICD10IPDNTREE = "ICD10IPDNTREE"

// procedureTree
export const PROCEDURETREE = "PROCEDURETREE"
export const PROCEDUREIPDNTREE = "PROCEDUREIPDNTREE"

// TODO: store in state and useContext
let defaultDateRangeIP: string | null = null
export const getDateRangeIP = () => {
  return defaultDateRangeIP
}

// TODO: store in state and useContext
let defaultDateRangeOPCRD: string | null = null
export const getDateRangeOPCRD = () => {
    return defaultDateRangeOPCRD
}

export const initialState: SettingsState = {
  values: {
    [DATA_RANGE_IP]: undefined,
    [STORYBOARD_HOME_PAGE]: undefined,
    [DEMO_COMPANY_MESSAGE]: undefined,
    [NOTIFICATIONS]: undefined,
    [ICD10TREE]: undefined,
    [ICD10IPDNTREE]: undefined,
    [PROCEDURETREE]: undefined,
    [PROCEDUREIPDNTREE]: undefined,
  }
}

const settings = createReducer(
  initialState,
  {
    SET_SETTINGS: (state, action) => {
      state.values = { ...state.values, ...action.settings }
      defaultDateRangeIP = state.values[DATA_RANGE_IP]
      defaultDateRangeOPCRD = state.values[DATA_RANGE_OPCRD]
    },
    SET_ICD10TREE: (state, action) => {
        state.values = { ...state.values, ICD10TREE: action.icd10tree }
    },
      SET_ICD10IPDNTREE: (state, action) => {
          state.values = { ...state.values, ICD10IPDNTREE: action.icd10IPDNTree }
      },
    SET_PROCEDURETREE: (state, action) => {
        state.values = { ...state.values, PROCEDURETREE: action.procedureTree }
    },
    SET_PROCEDUREIPDNTREE: (state, action) => {
        state.values = { ...state.values, PROCEDUREIPDNTREE: action.procedureIPDNTree }
    },
    SET_NOTIFICATIONS: (state, action) => {
      state.values = { ...state.values, NOTIFICATIONS: action.notifications}
    },
    MARK_NOTIFICATIONS_UNREAD: (state, actions) => {
        state.values = {
            ...state.values,
            NOTIFICATIONS: state.values.NOTIFICATIONS?.map(notification => ({...notification, isReadForUser: true}))
        }
    }
  })
  
export const selectValues = (state: RootState) => state.settings.values
export default settings